import Cookies from 'js-cookie'

import { Header } from 'site/NewHeader/entry'
import type { HeaderProps } from 'site/NewHeader/entry'

import { InstantSearch } from '../InstantSearch'
import { Layout } from '../layout'
import { PageEntry } from '../pages/entry'
import { CategoryPage } from '../pages/category'
import { ServerProvider } from './routes.context'
import { IS_CATEGORY, IS_SEARCH_BY_IMAGE } from '../utils/constants'
import { IS_ON_MOBILE_APP } from '../constants'

export type CategoryFiltersLabelProps = { [key: string]: string }

export type AlgoliaConfigProps = {
  indexName: string
  retailMediaIndexName: string
  searchByImageIndexName: string
  serviceIndexName: string
  appId: string
  apiKey: string
  facets: {
    [key: string]: string
  } | null
  maxFacets: number
}
export interface RouterProps extends HeaderProps {
  /**
   * Entry Key API domain
   */
  apiDomain: string

  /**
   * Algolia category data
   */
  meta: {
    id: {
      $oid: string
    }
    tree: string
    description: {
      top: string
      footer: string
    }
  }
}

function Routes(props: RouterProps) {
  const {
    socialLoginProviders,
    isBlackWeekend,
    isServicesSearchbarEnabled,
    meta,
    algolia,
    ...rest
  } = props

  const region = Cookies.get('region')
  const isGrandeSaoPauloRegion = region === 'grande_sao_paulo'
  const shouldShowServices =
    isServicesSearchbarEnabled && isGrandeSaoPauloRegion

  const CATEGORY_DATA = JSON.parse(String(meta))
  const baseAlgoliaConfig = JSON.parse(String(algolia))

  const ALGOLIA_DATA = {
    ...baseAlgoliaConfig,
    indexName: IS_SEARCH_BY_IMAGE
      ? baseAlgoliaConfig.searchByImageIndexName
      : baseAlgoliaConfig.indexName
  }

  return (
    <ServerProvider
      value={{
        ...rest,
        isServicesSearchbarEnabled: shouldShowServices,
        meta: CATEGORY_DATA,
        algolia: ALGOLIA_DATA
      }}>
      <InstantSearch categoryPageId={CATEGORY_DATA.tree} algolia={ALGOLIA_DATA}>
        {!IS_ON_MOBILE_APP && (
          <div data-testid="entry-key-algolia-header">
            <Header
              socialLoginProviders={socialLoginProviders}
              isBlackWeekend={isBlackWeekend}
              isServicesSearchbarEnabled={shouldShowServices}
              forceRouting={IS_CATEGORY}
              algolia={ALGOLIA_DATA}
            />
          </div>
        )}

        {IS_CATEGORY ? (
          <CategoryPage />
        ) : (
          <Layout>
            <PageEntry />
          </Layout>
        )}
      </InstantSearch>
    </ServerProvider>
  )
}

export default Routes
